module.exports = __webpack_public_path__ + "static/media/fccparagon.6447860c.png";